import { Locales } from '@griply/types';
import i18next from 'i18next';
import { useEffect } from 'react';

import { resolveSupportedLanguage } from './resolve-supported-language';

export const useApplyPopoverLanguage = (language: Locales | undefined) => {
  useEffect(() => {
    i18next.changeLanguage(resolveSupportedLanguage(language));
  }, [language]);
};
